import { Link } from "react-router-dom";
import type { MediaItem } from "@/types/media";

interface MediaCardProps {
  item: MediaItem;
  index?: number;
}

export default function MediaCard({ item, index = 0 }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group block cursor-pointer"
      style={{ animationDelay: `${Math.min(index, 8) * 60}ms` }}
    >
      <article className="relative overflow-hidden rounded-lg bg-background-100 ring-1 ring-background-200 animate-fade-up">
        <div className="relative w-full aspect-[2/3] overflow-hidden">
          <img
            src={item.poster}
            alt={`${item.title} 海报`}
            title={`${item.title} ${item.genres.join(" ")}`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-x-0 bottom-0 h-1/3 bg-gradient-to-t from-black/70 to-transparent" />
          <span className="absolute left-2 top-2 rounded-md bg-primary-900/85 px-2 py-0.5 text-[11px] font-medium text-background-50 backdrop-blur">
            {item.type}
          </span>
          <div className="absolute left-2 bottom-2 flex items-center gap-2">
            <span className="inline-flex items-center rounded-md bg-accent-500 px-1.5 py-0.5 font-label text-[11px] font-semibold text-foreground-950">
              {item.rating.toFixed(1)}
            </span>
            <span className="text-[11px] text-background-50/90">{item.year}</span>
          </div>
        </div>
        <div className="p-3">
          <h3 className="text-sm font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
            {item.title}
          </h3>
          <p className="mt-1 text-xs text-foreground-500 line-clamp-1">
            {item.genres.join(" · ")}
          </p>
          <p className="mt-1.5 text-xs leading-relaxed text-foreground-500 line-clamp-2">
            {item.synopsis}
          </p>
        </div>
      </article>
    </Link>
  );
}